import React from 'react';
import './GeneLogo.css';

const GeneLogo = ({ size = 'normal', showTagline = true }) => {
  const sizeClasses = {
    small: 'logo-small',
    normal: 'logo-normal',
    large: 'logo-large'
  };

  return (
    <div className={`gene-logo ${sizeClasses[size]}`}>
      {/* DNA Helix */}
      <span className="dna-helix">🧬</span>
      
      {/* Gene AI text */}
      <span className="gene-text">Gene</span>
      <span className="ai-text">AI</span>
      <span className="trademark">™</span>
      
      {/* Tagline */}
      {showTagline && (
        <span className="tagline">Genealogy Research Assistant</span>
      )}
    </div>
  );
};

export default GeneLogo;
